import './ServiceOfferButton.scss';

import React, { memo } from 'react';

import { IoChevronForward } from 'react-icons/io5';
import { PiUsers } from 'react-icons/pi';

interface ServiceOfferButtonProps {
  /** Number of help offers (e.g. 1) */
  count: number;
  onClick?: () => void;
  className?: string;
}

const ServiceOfferButton: React.FC<ServiceOfferButtonProps> = ({
  count,
  onClick,
  className = '',
}) => {
  return (
    <>
      <button
        type="button"
        className={`service-offer-button ${className}`.trim()}
        onClick={onClick}>
        <span className="service-offer-button__icon" aria-hidden>
          <PiUsers size={20} />
        </span>
        <span className="service-offer-button__label">
          {count}{' '}
          <span className="service-offer-button__label-underline">
            Help Offered
          </span>
        </span>
        <span className="service-offer-button__chevron" aria-hidden>
          <IoChevronForward size={20} />
        </span>
      </button>
    </>
  );
};

export default memo(ServiceOfferButton);
